import React, { useState } from 'react';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import Container from '@amzn/awsui-components-console/container';
import Header from '@amzn/awsui-components-console/header';
import Input from '@amzn/awsui-components-console/input';
import SpaceBetween from '@amzn/awsui-components-console/space-between';

interface TempContactInputProps {
  onConnect: (contactId: string) => void;
  onClose: () => void;
  isConnected: boolean;
}
// TODO: this is temporary component which will gets removed post Clinical AI Assistant in cchub work completed
export const TempContactInput: React.FC<TempContactInputProps> = ({
  onConnect,
  onClose,
  isConnected
}) => {
  const [contactId, setContactId] = useState('');

  // Customer state is no longer initialized over HTTP (the /initializeCustomerState
  // endpoint was removed). Connecting now only starts the WebSocket session for the
  // given contact id (a synchronous prop callback), so person id / permission inputs
  // are no longer collected here and there is no async work to await.
  const handleConnect = () => {
    if (!contactId.trim()) return;
    onConnect(contactId);
  };

  return (
    <Container
      header={
        <Header 
          variant="h3"
          actions={
            <Button 
              variant="icon" 
              iconName="close"
              onClick={onClose}
            />
          }
        >
          WebSocket Connection (Temporary)
        </Header>
      }
    >
      <SpaceBetween size="s" direction="vertical">
        <SpaceBetween size="s" direction="horizontal" alignItems="end">
          <Box>
            <Input
              value={contactId}
              onChange={({ detail }) => setContactId(detail.value)}
              placeholder="Enter Contact ID"
              disabled={isConnected}
            />
          </Box>
          <Button
            variant="primary"
            onClick={handleConnect}
            disabled={!contactId.trim() || isConnected}
          >
            Connect
          </Button>
        </SpaceBetween>
      </SpaceBetween>
    </Container>
  );
};
